module.exports = __webpack_public_path__ + "static/media/concert.ccfa59fa.jpg";